import React, { FunctionComponent } from "react";
import styles from "../../styles/home/AwardSection.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircle } from "@fortawesome/free-solid-svg-icons"

interface AwardSectionProps {
    
}
 
const AwardSection: FunctionComponent<AwardSectionProps> = () => {
    return (
        <div className={styles.awardSectionWrapper}>
            <h1>Build Award Winning Games with AI</h1>
            <img src="https://frontend-assets.buildbox.com/BB4_Homepage_Pocketamer_Awards.webp" loading="lazy" alt="awards" />
            <div className={styles.bulletPoints}> <FontAwesomeIcon icon={faCircle} /> Over a billion people have played games built on Buildbox</div>
            <div className={styles.bulletPoints}> <FontAwesomeIcon icon={faCircle} /> Over 40,000 new games are created every month</div>
            <h1>Apple regularly features Buildbox Games</h1>
            <img src="https://frontend-assets.buildbox.com/BB4_3Phones_Image.webp" loading="lazy" alt="phone-display" />
        </div>
    );
}
 
export default AwardSection;